document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('BackToTop');
  if (!btn) return;
  const showAfter = parseInt(btn.dataset.showAfter || '300', 10);
  const behavior = btn.dataset.scrollBehavior || 'smooth';

  const toggleVisibility = () => {
    if (window.scrollY > showAfter) {
      btn.style.display = 'flex';
    } else {
      btn.style.display = 'none';
    }
  };

  toggleVisibility();
  window.addEventListener('scroll', toggleVisibility);

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior });
  });
});
